import CircleIcon from '@/ui/CircleIcon/CircleIcon';
import { ActiveLink, SectionTitle } from '@/ui/index';
import { ArrowRightNew } from '@/icons/index';

import styles from './FixServices.module.scss';

const Card = ({ data, point }) => {
  const renderIconOrText = (() => {
    if (data?.icon) {
      return <CircleIcon path={data.icon} alt={data.icon.alt} />;
    }

    return <CircleIcon>{point}</CircleIcon>;
  })();

  return (
    <article
      className={styles['card-item']}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div>
        <div className={styles['card-item__icon-wrapper']}>
          {renderIconOrText}
        </div>
        <div className={styles['card-item__content']}>
          {data?.title && (
            <SectionTitle titleModify={styles['card-item__title']}>
              {data.title}
            </SectionTitle>
          )}
        </div>
      </div>
      <div>
        {data?.slug ? (
          <ActiveLink href={`/${data.slug}`}>
            <a
              title={data?.link_text}
              aria-label={data?.link_text}
              className={styles.link}
            >
              {data?.link_text}
              <ArrowRightNew width={18} />
            </a>
          </ActiveLink>
        ) : (
          <div className={styles.rotatedArrow}>
            <span>{data?.link_text}</span>
            <ArrowRightNew width={18} className={styles.scrolly} />
          </div>
        )}
      </div>
    </article>
  );
};

export default Card;
